module.exports = __webpack_public_path__ + "img/circle-bg.a3028531.png";